import ctl from '@netlify/classnames-template-literals';

const buttonStyle = ctl(`
  transition-transform 
  duration-300 
  self-center
`);

const listItemDataContainerAnimation = ctl(`
  overflow-hidden 
  transition-all 
  ease-in-out 
  delay-150 
  duration-300 
  pl-4 
`);

const listItemDataContainer = ctl(`
  bg-gray-50 
  rounded-b-lg 
  pb-2 
  mt-2 
  text-gray-800 
  leading-relaxed
`);

const textStyle = ctl(`
  text-sm 
  font-medium 
  text-gray-700
`);

const titleColor = ctl(`
  text-gray-800
`);

export default {
  buttonStyle,
  listItemDataContainerAnimation,
  listItemDataContainer,
  textStyle,
  titleColor,
};
